var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAscend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.61427 3.96767C7.81427 3.72519 8.18574 3.72519 8.38573 3.96767L11.6553 7.93186C11.9243 8.25798 11.6923 8.75 11.2696 8.75L4.73039 8.75C4.30766 8.75 4.07569 8.25798 4.34467 7.93186L7.61427 3.96767Z",
    fill: "var(--fontTertiary, #1b202c)",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscend);
export default __webpack_public_path__ + "static/media/sort-ascend.ddedf794e5703e46cbe3ba6478c58348.svg";
export { ForwardRef as ReactComponent };